var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHomeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 508,
    viewBox: "0 0 452 508",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M950.689 77.5395C906.794 11.6744 835.437 -34.3229 752.968 -44.0685C767.328 -77.5424 775.3 -114.422 775.3 -153.153C775.3 -169.113 773.934 -184.76 771.329 -199.998C749.092 -330.582 635.409 -430 498.484 -430C345.599 -430 221.685 -306.069 221.685 -153.185C221.685 -114.438 229.657 -77.5581 244.032 -44.0842C106.605 -27.8729 0 88.9957 0 230.801C0 294.187 21.3273 352.597 57.171 399.269C107.782 465.15 187.332 507.632 276.815 507.648C359.928 507.648 434.487 471.02 485.223 413.017C489.853 407.728 494.294 402.251 498.516 396.617C507.79 408.984 518.101 420.518 529.275 431.174C538.063 439.554 547.385 447.401 557.225 454.573C573.106 466.155 590.259 476.089 608.432 484.139C642.612 499.252 680.433 507.664 720.2 507.664C724.139 507.664 728.047 507.554 731.939 507.397C879.378 501.245 997 379.794 997 230.848C997 174.148 979.941 121.45 950.689 77.5552V77.5395Z",
    fill: "url(#paint0_linear_7372_2346)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7372_2346",
    x1: 520.5,
    y1: -54,
    x2: -75,
    y2: 584.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487821,
    stopColor: "#4745B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8281D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHomeBg);
export default __webpack_public_path__ + "static/media/logo-home-bg.470d8e039c5f0e511d7cff6b8d44e44c.svg";
export { ForwardRef as ReactComponent };